// Env-driven Firebase config. Nothing hardcoded — fill frontend/.env.
// Until .env is populated these values are empty strings; the app will show a
// clear "Firebase not configured" banner (see firebase/init.js) instead of crashing.

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "",
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? "",
};

export const PUBLIC_BASE_URL =
  import.meta.env.VITE_PUBLIC_BASE_URL ?? "https://einvite.to";

export const USE_EMULATORS =
  String(import.meta.env.VITE_USE_EMULATORS ?? "false") === "true";

export const isConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

// Go backend base URL. In prod this is https://einvite.to/api
export const API_BASE =
  import.meta.env.VITE_API_BASE ?? "https://einvite.to/api";
